// @ts-nocheck
import publishConfigurationPanel from './config/publishConfigurationPanel';
import publishSuccessPanel from './publishSuccessPanel';
import publishRCSuccessPanel from './publishRCSuccessPanel';
import publishRCPreparePanel from './publishRCPreparePanel';
import shoutoutPanel from './content/shoutoutPanel';
import fourthPublishSuccessPanel from './fourthPublishSuccessPanel/fourthPublishSuccessPanel';
import publishErrorPanel from './publishErrorPanel/PublishErrorPanel';

const config = {
  publishConfigurationPanel,
};

export {
  config,
  publishSuccessPanel,
  publishErrorPanel,
  publishRCSuccessPanel,
  fourthPublishSuccessPanel,
  shoutoutPanel as shoutOut,
  publishRCPreparePanel,
};
